"use client";

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

const komputerBekasi: ReactNode = (
  <>
    <h2 className="text-xl font-bold mb-2">Kenapa Sewa Komputer Bekasi Sekarang Lebih Relevan daripada Beli?</h2>

    <p className="mb-4">
      Di tengah padatnya kawasan industri seperti <strong>Jababeka</strong>, <strong>Cibitung</strong>, hingga <strong>Cikarang</strong>, kebutuhan digitalisasi makin nyata. Tak semua perusahaan perlu membeli ratusan unit komputer hanya untuk operasional proyek 3 bulan. Di sinilah kehadiran layanan <strong>sewa komputer Bekasi</strong> menjadi solusi efisien, cepat, dan bisa disesuaikan, baik dari sisi <em>harga, brand, spek, maupun tipe komputer</em>.
    </p>

    <h2 className="text-lg font-semibold mb-2">Sewa Komputer Bekasi: Strategi Operasional Tanpa Beban Investasi</h2>

    <p className="mb-4">
      Waktu adalah modal terbesar dalam bisnis. Saat kamu memilih <strong>sewa komputer Bekasi</strong>, kamu tak lagi mengurusi pembelian, instalasi, hingga perawatan. Tinggal pakai. Kami yang tangani sisanya. Dan jika butuh komputer spek tinggi? Kami sediakan berbagai <strong>tipe dan brand ternama</strong>, dari Core i5 generasi 10, i7 dengan SSD 512GB, hingga workstation grafis berat.
    </p>

    <ul className="space-y-5 mb-6">
      <li className="bg-white shadow-md rounded-2xl p-6 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Layanan Sewa Komputer Bekasi Menjangkau Hingga Tambun & MM2100</h3>
        <p className="text-sm">
          Kamu di <strong>Tambun</strong>, <strong>Harapan Indah</strong>, atau kawasan <strong>MM2100</strong>? Unit <strong>komputer sewaan</strong> kami bisa dikirim ke lokasi kamu dalam waktu 2 jam (atau kurang). Kami memahami urgensi operasional dan meeting dadakan.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-2xl p-6 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Tipe Komputer Beragam, Siap Sewa Kapan Saja</h3>
        <p className="text-sm">
          Mau komputer standar kantor, atau <strong>komputer spek tinggi</strong> untuk desain dan data processing? Semua tersedia. Pilihan <strong>brand Lenovo, HP, ASUS, Dell</strong> dari Core i3 hingga Xeon. Semuanya bisa <strong>sewa komputer Bekasi</strong> secara fleksibel.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-2xl p-6 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Harga Sewa Komputer Bekasi Bisa Disesuaikan</h3>
        <p className="text-sm">
          Sewa 5 unit atau 50 unit? Butuh harian, mingguan, atau bulanan? Harga kami transparan dan bisa disesuaikan. Semakin lama <strong>sewa komputer Bekasi</strong>, semakin hemat investasimu.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-2xl p-6 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Gratis Antar-Jemput & Instalasi</h3>
        <p className="text-sm">
          Kami tak sekadar antar. Kami juga <strong>instal software</strong> sesuai kebutuhan kamu, dari Microsoft Office, Zoom, hingga Adobe Suite. Selesai sewa? Kami jemput kembali tanpa biaya tambahan. Totalitas layanan <strong>sewa komputer Bekasi</strong> yang tak membebani.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-2xl p-6 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Teknisi Lokal Bekasi Standby 24 Jam</h3>
        <p className="text-sm">
          Kami percaya pelayanan bukan soal jam kerja, tapi kesiapsiagaan. Ketika kamu <strong>sewa komputer</strong> dari kami, kamu otomatis mendapatkan <em>support teknis 24/7</em>, termasuk weekend dan hari libur nasional.
        </p>
      </li>
    </ul>

    <h2 className="text-xl font-bold mb-3">Dukungan Maintenance Penuh Selama Masa Sewa</h2>
    <p className="mb-4">
      Setiap unit <strong>komputer sewaan Bekasi</strong> yang keluar dari gudang kami telah melalui 25+ checklist inspeksi. Tapi kalau ada kendala di tengah jalan? Kami siap kirim unit pengganti. Tanpa biaya tambahan. Tanpa drama.
    </p>

    <h2 className="text-xl font-bold mb-3">Durasi Sewa Komputer Bekasi yang Fleksibel Banget</h2>
    <p className="mb-4">
      Untuk kamu yang butuh cepat, kami tawarkan durasi harian. Untuk pelatihan intensif? Ada paket mingguan. Dan untuk operasional kantor atau produksi video? Ambil paket bulanan dengan harga spesial. Semuanya bisa diatur sesuai alur kerja kamu.
    </p>

    <h2 className="text-xl font-bold mb-3">Sewa Komputer Bekasi Itu Bukan Sekadar Transaksi, Tapi Investasi</h2>
    <p className="mb-6">
      Di era digital, kecepatan adaptasi lebih penting dari kepemilikan aset. Dengan <strong>sewa komputer Bekasi</strong>, kamu membayar solusi, bukan hanya perangkat. Kamu beli waktu, fleksibilitas, dan fokus. Itu sebabnya perusahaan besar mulai tinggalkan pola beli - dan pindah ke model sewa.
    </p>

    <CTA
      title="Siap di Area Bekasi Sampai Cikarang Bosku?"
      description="🚚 Butuh sewa komputer di Bekasi sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Komputer Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20komputer%20untuk%20Bekasi%20dan%20sekitarnya.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ category="Komputer" />
  </>
);

export default komputerBekasi;